import React from 'react';

const ratings = [
  { value: 'exceeds', label: 'Exceeds Expectations', color: 'text-green-600', bgColor: 'bg-green-50' },
  { value: 'meets', label: 'Meets Expectations', color: 'text-blue-600', bgColor: 'bg-blue-50' },
  { value: 'needs-improvement', label: 'Needs Improvement', color: 'text-red-600', bgColor: 'bg-red-50' }
];

export default function RatingSelector({ value, onChange, disabled = false }) {
  const selectedRating = ratings.find(r => r.value === value);
  return (
    <div className="min-w-[200px]">
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 ${selectedRating ? selectedRating.color : ''}`}
      >
        <option value="">Select Rating</option>
        {ratings.map(rating => (
          <option key={rating.value} value={rating.value}>{rating.label}</option>
        ))}
      </select>
      {selectedRating && (
        <div className={`mt-2 px-2 py-1 rounded text-xs font-medium ${selectedRating.bgColor} ${selectedRating.color}`}>
          ✓ {selectedRating.label}
        </div>
      )}
    </div>
  );
}
